import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-fit p-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-5"
}
const _hoisted_4 = { class: "col text-right" }
const _hoisted_5 = {
  key: 0,
  class: "overflow-y-none scrollbar flex-1 px-0"
}
const _hoisted_6 = {
  key: 1,
  class: "bg-white p-3 my-3 border-round-sm text-sm mt-5"
}

import { onMounted, onBeforeUnmount, ref } from 'vue';
import VirtualScroller from 'primevue/virtualscroller';
import ActivityLogItem from '@/components/ActivityLog/ActivityLogItem.vue';
import { useActivityLogStore } from '@/store';
import { can, useDateTime, useRequestCancel, useRouting } from '@/composables';
import { PERMISSIONS, REQUEST } from '@/enum';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityLog',
  setup(__props) {

const dateUtils = useDateTime();
const dates = ref<Date[] | null>([]);
const activityLogStore = useActivityLogStore();
const { logs, loading } = storeToRefs(activityLogStore);
const $routing = useRouting();
const searchFilter = ref();

onMounted(async () => {
  activityLogStore.restorePaginationState(true);
  defineDefaultDates();
  await init();
});

const init = async () => {
  defineDateQueryParams();
  await getLogs();
};

const defineDefaultDates = () => {
  const end = new Date();
  const start = new Date(end.getTime() - 28 * 24 * 60 * 60 * 1000);
  const defaultDates: Date[] = [start, end];

  dates.value = defaultDates;
  activityLogStore.filters.start_at = dateUtils.formatDateForApi(start);
  activityLogStore.filters.end_at = dateUtils.formatDateForApi(end);
};

const defineDateQueryParams = () => {
  if (dates.value && dates.value.length > 1) {
    activityLogStore.filters.start_at = dateUtils.formatDateForApi(dates.value[0]);
    activityLogStore.filters.end_at = dateUtils.formatDateForApi(dates.value[1]);

    $routing.addQueryParams({
      start_at: activityLogStore.filters.start_at,
      end_at: activityLogStore.filters.end_at,
    });
  }
};

const onDateRangeChange = async (event: Date[]) => {
  activityLogStore.restorePaginationState(true);
  dates.value = event;
  defineDateQueryParams();
  await getLogs();
};

const onSearch = async (search: string) => {
  const hasSearchTerm = search.length >= 3;

  if (hasSearchTerm) {
    activityLogStore.filters.search = search;
    await init();
  }
};

onBeforeUnmount(() => useRequestCancel().requestSaverAbort(REQUEST.LOGS));

const onLazyLoadLogs = async (event) => {
  const difference = event.last - event.first;

  if (difference >= 30 && difference <= 35) {
    await getLogs();
  }
};

const getLogs = async () => {
  await activityLogStore.getLogs(Number($routing.route.params.id));
};

return (_ctx: any,_cache: any) => {
  const _component_AppDateRangePicker = _resolveComponent("AppDateRangePicker")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h2", null, "Activity Log", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(can)([_unref(PERMISSIONS).PERSON_LOGS_INDEX_FILTER_DATE]))
            ? (_openBlock(), _createBlock(_component_AppDateRangePicker, {
                key: 0,
                modelValue: dates.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dates).value = $event)),
                class: "flex-1 mr-3 mb-3 min-w-min w-full",
                value: dates.value,
                onChange: onDateRangeChange
              }, null, 8, ["modelValue", "value"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(can)([_unref(PERMISSIONS).PERSON_LOGS_INDEX_SEARCH]))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_IconField, { "icon-position": "left" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputIcon, {
                    class: "p-input-icon-left",
                    style: {"z-index":"100"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        name: "search",
                        class: "text-lg"
                      })
                    ]),
                    _: 1
                  }),
                  (_unref(can)([_unref(PERMISSIONS).PERSON_LOGS_INDEX_SEARCH]))
                    ? _withDirectives((_openBlock(), _createBlock(_component_InputText, {
                        key: 0,
                        modelValue: searchFilter.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchFilter).value = $event)),
                        class: "w-full pl-5",
                        placeholder: "Search",
                        "min-length": 3
                      }, null, 8, ["modelValue"])), [
                        [_directive_debounce, onSearch, "600ms"]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_unref(loading))
            ? (_openBlock(), _createBlock(_component_Spinner, {
                key: 0,
                size: 25
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (_unref(logs).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(VirtualScroller), {
              items: _unref(logs),
              "item-size": 50,
              lazy: true,
              "scroll-height": "550px",
              onLazyLoad: onLazyLoadLogs
            }, {
              item: _withCtx(({ item }) => [
                (_openBlock(), _createBlock(ActivityLogItem, {
                  key: item.id,
                  "access-tenant": item.access_tenant,
                  subject: item.subject,
                  description: item.description,
                  "subject-type": item.subject_type,
                  causer: item.causer,
                  "impersonated-by": item.impersonated_by,
                  event: item.event,
                  properties: item.properties,
                  custom: item.custom,
                  "time-ago": item.updated_at,
                  changes: item.changes
                }, null, 8, ["access-tenant", "subject", "description", "subject-type", "causer", "impersonated-by", "event", "properties", "custom", "time-ago", "changes"]))
              ]),
              _: 1
            }, 8, ["items"])
          ]))
        : _createCommentVNode("", true),
      (!_unref(loading) && !_unref(logs).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", { class: "text-center" }, "No activity was found.", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})